/*
 * Per-section "Add to Home Screen" identities.
 *
 * iOS 16.4+ and Chrome both take the launch URL from the manifest's
 * `start_url`, not from the page you happen to be on when you tap Add to
 * Home Screen. With a single site-wide manifest every icon therefore lands
 * on "/". Each entry below points at its own manifest file in public/, and
 * PwaManifest swaps the <link rel="manifest"> as you navigate so the icon
 * you save opens the section you saved it from.
 *
 * `scope` stays "/" in every manifest, so once launched the app can still
 * navigate anywhere without kicking out to Safari.
 *
 * To add a section: drop icons/<slug>-{180,192,512}.png and
 * public/manifest-<slug>.json alongside the existing ones, then add a row.
 */
const PUBLIC_URL = process.env.PUBLIC_URL || "";

/*
 * The manifest the *document* was served with, captured at module-evaluation
 * time - i.e. before PwaManifest's effect can swap it. iOS only ever honours
 * this one, so AddToHomeScreen compares against it to decide whether a full
 * page load is needed before the Share sheet will save the right app.
 */
export const DOCUMENT_MANIFEST =
  typeof document === "undefined"
    ? null
    : document.querySelector('link[rel="manifest"]')?.getAttribute("href") ||
      null;

export const DEFAULT_APP = {
  title: "Plate Passion",
  manifest: `${PUBLIC_URL}/manifest.json`,
  appleTouchIcon: `${PUBLIC_URL}/apple-touch-icon.png`,
};

const section = (path, slug, title) => ({
  path,
  title,
  manifest: `${PUBLIC_URL}/manifest-${slug}.json`,
  appleTouchIcon: `${PUBLIC_URL}/icons/${slug}-180.png`,
});

const HOME_SCREEN_APPS = [
  section("/shopping", "shopping", "Shopping"),
  section("/weekly-plan", "weekly-plan", "Weekly Plan"),
  section("/macro-calculator", "macro-calculator", "Macros"),
  section("/workout-tracker", "workout-tracker", "Workouts"),
];

// Exact match only: "/shopping" must not claim "/shopping_aisles".
export function appForPath(pathname) {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return HOME_SCREEN_APPS.find((app) => app.path === path) || DEFAULT_APP;
}

export default HOME_SCREEN_APPS;
